import { api } from "../../apiProvider";
import { WfsBlobServiceServiceParams } from "./wfsBlobService.service";
import { defaultParams } from "../wfs-service/wfsService.adapter";
import { ApiWfsServiceResponse } from "../wfs-service/types";

export const wfsBlobServiceAdapter = async (
    params: WfsBlobServiceServiceParams
): Promise<ApiWfsServiceResponse | string> => {
    const merged = { ...defaultParams, ...params };

    const requestParams = Object.keys(merged)
        .map((key) => {
            return key + "=" + (merged as any)[key];
        })
        .join("&");
    const resp = await api.wfsService(requestParams);

    return resp.data;
};
